import { useState, useRef, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Button } from 'primereact/button'

import ColorPickerPopup from '@aytm/app/stats/page/question-views/components/word-cloud/ColorPickerPopup'

const ColorLab = ({ container, mode, colors, background, onChange }) => {
  const [opened, setOpened] = useState(false)

  const colorPickerRef = useRef(null)
  const colorPickerPopupRef = useRef(null)

  const onClose = useCallback(() => setOpened(false), [])

  useEffect(() => {
    if (!opened) return

    const handleClickOutside = event => {
      if (colorPickerRef.current?.contains(event.target)) return
      if (colorPickerPopupRef.current?.contains(event.target)) return

      setOpened(false)
    }

    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [opened])

  return (
    <>
      <Button
        ref={colorPickerRef}
        className="p-button-rounded p-button-blue p-button-secondary"
        label="Custom"
        icon="icon-aytmfd-color-picker"
        onClick={() => setOpened(!opened)}
      />
      {opened ? (
        <ColorPickerPopup
          ref={colorPickerPopupRef}
          container={container}
          target={colorPickerRef.current}
          mode={mode}
          colors={colors}
          background={background}
          offsetTop={-30}
          offsetLeft={60}
          onClose={onClose}
          onChange={onChange}
        />
      ) : null}
    </>
  )
}

ColorLab.propTypes = {
  container: PropTypes.any,
  mode: PropTypes.string,
  colors: PropTypes.array,
  background: PropTypes.string,
  onChange: PropTypes.func
}

ColorLab.displayName = 'ColorLab'

export default ColorLab
